import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 6rem;
  align-items: start;

  h2{
    display: inline-block;
    margin-bottom: 2rem;
    font-size: 3rem;
    margin-top: 0rem;
    color: var(--green);
  }

  h3{
    color: var(--green);
    font-size: 2.2rem;
    margin-bottom: 1.6rem;
  }

  p{
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
    line-height: 1.6;
    margin-bottom: 1.8rem;
  }

  .highlight{
    color: var(--green);
    font-weight: 700;
  }

  .skill-group{
    margin-bottom: 2rem;

    h4{
      font-size: 1.2rem;
      text-transform: uppercase;
      letter-spacing: 0.2rem;
      opacity: 0.7;
      margin-bottom: 0.8rem;
    }
  }

  .hard-skills{
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .hability{
    display: flex;
    align-items: center;
    gap: 0.9rem;
    padding: 0.9rem 1.4rem 0.9rem 1rem;
    border-radius: 1rem;
    border: 1px solid rgba(35, 206, 107, 0.25);
    background: rgba(35, 206, 107, 0.06);
    transition: transform 0.25s, border-color 0.25s, box-shadow 0.25s;

    img{
      width: 2.8rem;
      height: 2.8rem;
      object-fit: contain;
    }

    span{
      font-size: 1.4rem;
      font-weight: 600;
      white-space: nowrap;
    }

    &:hover{
      transform: translateY(-3px);
      border-color: var(--green);
      box-shadow: 0 4px 12px rgba(35, 206, 107, 0.2);
    }
  }

  .about-image{
    text-align: center;
    img{
      margin-top: 2rem;
      width: 50%;
    }
  }

  @media (max-width: 960px){
    display: block;
    text-align: center;

    .about-skills{
      margin-top: 4rem;
    }

    .hard-skills{
      justify-content: center;
    }

    .about-image{
      display: flex;
      max-width: 100%;
      img{
        margin-top: 2rem;
        width: 100%;
      }
    }
  }

`
